import { EndpointWithoutRequest, Http } from "Application";
import { AppUrls } from "AppUrls";

export class GETLeftStudentSessionResponse {
    public leftStudentList: any[] = [];
    public studentList: any[] = [];
}

export class GETLeftStudentSessionEndPoint extends EndpointWithoutRequest<GETLeftStudentSessionResponse> {
    constructor(startDate: string) {
        super();
        this.verb(Http.Get);
        this.path(AppUrls.Server.WeeklyRota.GetAllLeftStudentSession.replace(":startdate", startDate));
    }

    public async HandleResponseAsync(response: GETLeftStudentSessionResponse): Promise<GETLeftStudentSessionResponse> {
        return response;
    }
}
